import { SpecialisationHealth } from 'modules/Monitoring/types'

import { QueueHealthDetailFormattedData } from '../types'

export const prepareTableData = (
  data: SpecialisationHealth[],
): QueueHealthDetailFormattedData[] => {
  return data.map(({ specialisation, metrics, queues }) => ({
    ...specialisation,
    ...metrics,
    subRows: queues.map(({ queue, metrics: queueMetrics }) => ({
      name: queue.name,
      id: queue.id,
      ...queueMetrics,
    })),
  }))
}
